'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require('api/constants');

var constants = _interopRequireWildcard(_constants);

var _IBonusError = require('api/IBonusError');

var _IBonusError2 = _interopRequireDefault(_IBonusError);

var _Factory = require('Models/Factory');

var _Factory2 = _interopRequireDefault(_Factory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IBonusApi = function () {
    function IBonusApi(client, storage) {
        var _this = this;

        (0, _classCallCheck3.default)(this, IBonusApi);

        this._send = function (path) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return _this.client.post(path, { data: data }).then(function (result) {
                var status = !!result.status;
                var dataError = [];

                //Для быстрой отладки
                //  console.log('path', path);
                //  console.log('data', data);
                //  console.log('status', status);

                if (status) {
                    return result.result;
                } else {
                    if (result.result.hasOwnProperty('dataError')) {
                        dataError = result.result.dataError;
                    }
                    if (result.result.params && result.result.params.length) {
                        dataError = dataError.concat(result.result.params);
                    }
                    throw new _IBonusError2.default({
                        message: result.result.error ? result.result.error.message : null,
                        title: result.result.title || '',
                        code: result.result.code || '',
                        trace: result.result.error ? result.result.error.trace : null,
                        dataError: dataError
                    });
                }
            });
        };

        this.client = client;
        this.storage = storage;
    }

    (0, _createClass3.default)(IBonusApi, [{
        key: 'user',
        get: function get() {
            var _this2 = this;

            return {
                /**
                 * Авторизует пользователя по логину и паролю
                 * @param {String} username Логин пользователя (Email)
                 * @param {String} password Пароль пользователя
                 * @param {String} client_id ID клиента (приложения)
                 * @param {String} client_secret Секретный ключ клиента (приложения)
                 * @param {String} captcha Ре-капча
                 * @param shopId
                 *
                 * @returns {Promise}
                 */
                authentication: function authentication(_ref) {
                    var username = _ref.username,
                        password = _ref.password,
                        client_id = _ref.client_id,
                        client_secret = _ref.client_secret,
                        _ref$captcha = _ref.captcha,
                        captcha = _ref$captcha === undefined ? null : _ref$captcha,
                        _ref$shopId = _ref.shopId,
                        shopId = _ref$shopId === undefined ? null : _ref$shopId;

                    var data = {
                        username: username, password: password, client_id: client_id, client_secret: client_secret, remember_me: false
                    };
                    if (captcha) {
                        data.captcha_token = captcha;
                    }
                    if (shopId) {
                        data.online_shop_id = shopId;
                    }
                    return _this2._send(constants.IBONUS_PATH_USER_AUTHENTICATION, data);
                },
                register: function register(_ref2) {
                    var password = _ref2.password,
                        shopId = _ref2.shopId,
                        params = (0, _objectWithoutProperties3.default)(_ref2, ['password', 'shopId']);

                    return _this2._send(constants.IBONUS_PATH_USER_REGISTER_BY_PHONE, (0, _extends3.default)({
                        password: password, online_shop_id: shopId }, params));
                },
                confirmRegister: function confirmRegister(_ref3) {
                    var password = _ref3.password,
                        shopId = _ref3.shopId,
                        params = (0, _objectWithoutProperties3.default)(_ref3, ['password', 'shopId']);

                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_REGISTER_BY_PHONE, (0, _extends3.default)({
                        password: password, online_shop_id: shopId }, params));
                },
                registerOneClick: function registerOneClick(_ref4) {
                    var shopId = _ref4.shopId,
                        params = (0, _objectWithoutProperties3.default)(_ref4, ['shopId']);

                    return _this2._send(constants.IBONUS_PATH_USER_REGISTER_ONE_CLICK, (0, _extends3.default)({
                        online_shop_id: shopId }, params));
                },
                confirmRegisterOneClick: function confirmRegisterOneClick(_ref5) {
                    var shopId = _ref5.shopId,
                        params = (0, _objectWithoutProperties3.default)(_ref5, ['shopId']);

                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_REGISTER_ONE_CLICK, (0, _extends3.default)({
                        online_shop_id: shopId }, params));
                },
                updateAccessToken: function updateAccessToken(_ref6) {
                    var client_id = _ref6.client_id,
                        client_secret = _ref6.client_secret,
                        refresh_token = _ref6.refresh_token;

                    return _this2._send(constants.IBONUS_PATH_USER_UPDATE_ACCESS_TOKEN, {
                        client_id: client_id, client_secret: client_secret, refresh_token: refresh_token
                    });
                },
                getData: function getData(_ref7) {
                    var client_id = _ref7.client_id,
                        client_secret = _ref7.client_secret,
                        access_token = _ref7.access_token,
                        channel_id = _ref7.channel_id;

                    return _promise2.default.all([_this2._send(constants.IBONUS_PATH_USER_GET_DATA, {
                        client_id: client_id, client_secret: client_secret, access_token: access_token
                    }), _this2._send(constants.IBONUS_PATH_GET_COUPONS_AND_BALANCE, {
                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id
                    })]).then(function (result) {

                        var userData = (0, _extends3.default)({}, result[0], { amount: result[1].amount, coupons: result[1].coupons,
                            loyaltySettings: result[1].settings, count_postpone: result[1].count_postpone });
                        return userData;
                    });
                },
                getWishList: function getWishList(_ref8) {
                    var client_id = _ref8.client_id,
                        client_secret = _ref8.client_secret,
                        access_token = _ref8.access_token,
                        channel_id = _ref8.channel_id,
                        wish_list = _ref8.wish_list;

                    return _this2._send(constants.IBONUS_PATH_GET_WISH_LIST, {
                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id, wish_list: wish_list
                    }).then(function (result) {
                        return result;
                    });
                },
                setWishList: function setWishList(_ref9) {
                    var client_id = _ref9.client_id,
                        client_secret = _ref9.client_secret,
                        access_token = _ref9.access_token,
                        channel_id = _ref9.channel_id,
                        wish_list = _ref9.wish_list;

                    return _this2._send(constants.IBONUS_PATH_SET_WISH_LIST, {
                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id, wish_list: wish_list
                    });
                },
                postponeBasket: function postponeBasket(params) {
                    return _this2._send(constants.IBONUS_PATH_CREATE_POSTPONE_BASKET, params);
                },
                getPostpone: function getPostpone(params) {
                    return _this2._send(constants.IBONUS_PATH_GET_POSTPONE_BASKET, params);
                },
                deletePostpone: function deletePostpone(params) {
                    return _this2._send(constants.IBONUS_PATH_DELETE_POSTPONE_BASKET, params);
                },
                mergePostpone: function mergePostpone(params) {
                    return _this2._send(constants.IBONUS_PATH_MERGE_POSTPONE_BASKET, params);
                },
                logout: function logout(_ref10) {
                    var client_id = _ref10.client_id,
                        client_secret = _ref10.client_secret,
                        access_token = _ref10.access_token,
                        refresh_token = _ref10.refresh_token;

                    return _this2._send(constants.IBONUS_PATH_USER_LOGOUT, {
                        client_id: client_id, client_secret: client_secret, access_token: access_token, refresh_token: refresh_token
                    });
                },
                getCouponsAndBalance: function getCouponsAndBalance(_ref11) {
                    var client_id = _ref11.client_id,
                        client_secret = _ref11.client_secret,
                        access_token = _ref11.access_token,
                        channel_id = _ref11.channel_id;

                    return _this2._send(constants.IBONUS_PATH_GET_COUPONS_AND_BALANCE, {
                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id
                    });
                },
                order: {
                    create: function create(params) {
                        return _this2._send(constants.IBONUS_PATH_USER_ORDER_CREATE, params);
                    },
                    /**
                     * Получить массив заказов покупателя в соответствии с фильтром Необязательные параметры
                     *
                     * @param {channel, service_in_id, status_id, order_id, cashier_id, device_id, begin_date, end_date, payment_in_number, page_number, page_size} params
                     */
                    get: function get() {
                        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        return _this2._send(constants.IBONUS_PATH_USER_ORDER_GET, params);
                    },
                    pay: function pay(_ref12) {
                        var channel_id = _ref12.channel_id,
                            client_secret = _ref12.client_secret,
                            client_id = _ref12.client_id,
                            order_id = _ref12.order_id,
                            access_token = _ref12.access_token;

                        return _this2._send(constants.IBONUS_PATH_USER_ORDER_PAY, { channel_id: channel_id, client_secret: client_secret, client_id: client_id, order_id: order_id, access_token: access_token });
                    },
                    /**
                     *Метод для редактирования заказа
                     */
                    set: function set(_ref13) {
                        var order_id = _ref13.order_id,
                            client_secret = _ref13.client_secret,
                            client_id = _ref13.client_id,
                            _ref13$client_comment = _ref13.client_comment,
                            client_comment = _ref13$client_comment === undefined ? null : _ref13$client_comment,
                            _ref13$delivery_addre = _ref13.delivery_address,
                            delivery_address = _ref13$delivery_addre === undefined ? null : _ref13$delivery_addre,
                            _ref13$service_in_slu = _ref13.service_in_slug,
                            service_in_slug = _ref13$service_in_slu === undefined ? null : _ref13$service_in_slu,
                            access_token = _ref13.access_token;

                        var params = { client_secret: client_secret, client_id: client_id, order_id: order_id, access_token: access_token };
                        if (client_comment) {
                            params['client_comment'] = client_comment;
                        }
                        if (service_in_slug) {
                            params['service_in_slug'] = service_in_slug;
                        }
                        if (delivery_address) {
                            params['delivery_address'] = delivery_address;
                        }
                        return _this2._send(constants.IBONUS_PATH_ORDER_UPDATE, params);
                    },
                    setPayOrder: function setPayOrder(_ref14) {
                        var order_id = _ref14.order_id,
                            client_secret = _ref14.client_secret,
                            client_id = _ref14.client_id,
                            _ref14$client_comment = _ref14.client_comment,
                            client_comment = _ref14$client_comment === undefined ? null : _ref14$client_comment,
                            _ref14$service_in_slu = _ref14.service_in_slug,
                            service_in_slug = _ref14$service_in_slu === undefined ? null : _ref14$service_in_slu,
                            _ref14$delivery_addre = _ref14.delivery_address,
                            delivery_address = _ref14$delivery_addre === undefined ? null : _ref14$delivery_addre,
                            access_token = _ref14.access_token,
                            _ref14$discount_sum = _ref14.discount_sum,
                            discount_sum = _ref14$discount_sum === undefined ? 0 : _ref14$discount_sum,
                            _ref14$coupon_id = _ref14.coupon_id,
                            coupon_id = _ref14$coupon_id === undefined ? null : _ref14$coupon_id,
                            _ref14$coupon_token = _ref14.coupon_token,
                            coupon_token = _ref14$coupon_token === undefined ? null : _ref14$coupon_token,
                            _ref14$customer_coupo = _ref14.customer_coupon_id,
                            customer_coupon_id = _ref14$customer_coupo === undefined ? null : _ref14$customer_coupo,
                            _ref14$custom_fields = _ref14.custom_fields,
                            custom_fields = _ref14$custom_fields === undefined ? null : _ref14$custom_fields,
                            _ref14$child_orders = _ref14.child_orders,
                            child_orders = _ref14$child_orders === undefined ? null : _ref14$child_orders,
                            _ref14$captcha = _ref14.captcha,
                            captcha = _ref14$captcha === undefined ? null : _ref14$captcha;


                        var params = { client_secret: client_secret, client_id: client_id, order_id: order_id, access_token: access_token };
                        if (client_comment) {
                            params['client_comment'] = client_comment;
                        }
                        if (service_in_slug) {
                            params['service_in_slug'] = service_in_slug;
                        }
                        if (discount_sum) {
                            params['discount_sum'] = discount_sum;
                        }
                        if (coupon_id) {
                            params['coupon_id'] = coupon_id;
                        }
                        if (customer_coupon_id) {
                            params['customer_coupon_id'] = customer_coupon_id;
                        }
                        if (coupon_token) {
                            params['coupon_token'] = coupon_token;
                        }
                        if (delivery_address) {
                            params['delivery_address'] = delivery_address;
                        }
                        if (custom_fields) {
                            params['custom_fields'] = custom_fields;
                        }
                        if (child_orders) {
                            params['child_orders'] = child_orders;
                        }
                        if (captcha) {
                            params['captcha'] = captcha;
                        }
                        return _this2._send(constants.IBONUS_PATH_USER_ORDER_CREATE_PAY, params);
                    },
                    edit: function edit(params) {
                        return _this2._send(constants.IBONUS_PATH_ORDER_EDIT, params);
                    },
                    cancel: function cancel(_ref15) {
                        var order_id = _ref15.order_id,
                            channel_id = _ref15.channel_id,
                            client_secret = _ref15.client_secret,
                            client_id = _ref15.client_id,
                            access_token = _ref15.access_token;

                        var params = { client_secret: client_secret, client_id: client_id, order_id: order_id, channel_id: channel_id, access_token: access_token };

                        return _this2._send(constants.IBONUS_PATH_ORDER_CANCEL, params);
                    }
                },
                channel: {
                    /**
                     * Получить массив настроек онлайн магазина
                     *
                     * @param {int} channel_id id канала продаж, если не передан будем искать по домену
                     * @param {String} domain Домен
                     *
                     * @return {Promise}
                     */
                    getOnlineShopSettings: function getOnlineShopSettings(_ref16) {
                        var _ref16$channel_id = _ref16.channel_id,
                            channel_id = _ref16$channel_id === undefined ? null : _ref16$channel_id,
                            _ref16$domain = _ref16.domain,
                            domain = _ref16$domain === undefined ? null : _ref16$domain;

                        var params = {};
                        if (channel_id) {
                            params['channel_id'] = channel_id;
                        }
                        if (domain) {
                            params['domain'] = domain;
                        }
                        return _this2._send(constants.IBONUS_PATH_USER_CHANNEL_GET_ONLINE_SHOP_SETTINGS, params).then(function (result) {
                            return _Factory2.default.create('ShopSettingsResponse', result);
                        });
                    }
                },
                paymentIn: {
                    pay: function pay(_ref17) {
                        var account_id = _ref17.account_id,
                            operation_id = _ref17.operation_id,
                            access_token = _ref17.access_token,
                            channel_id = _ref17.channel_id,
                            client_id = _ref17.client_id,
                            client_secret = _ref17.client_secret,
                            _ref17$check_code = _ref17.check_code,
                            check_code = _ref17$check_code === undefined ? null : _ref17$check_code;

                        var params = {
                            account_id: account_id,
                            operation_id: operation_id,
                            access_token: access_token,
                            channel_id: channel_id,
                            client_id: client_id,
                            client_secret: client_secret
                        };
                        if (check_code) {
                            params['check_code'] = check_code;
                        }
                        return _this2._send(constants.IBONUS_PATH_USER_PAYMENT_IN_PAY, params);
                    },

                    beforePay: function beforePay(params) {
                        return _this2._send(constants.IBONUS_PATH_USER_PAYMENT_IN_BEFORE_PAY, params);
                    }
                },
                /**
                 * Пулучение выписки по счёту для пользователя
                 */
                getPipoOperations: function getPipoOperations(params) {
                    return _this2._send(constants.IBONUS_PATH_PIPO_GET_OPERATIONS, (0, _extends3.default)({}, params));
                },

                onlineShop: {
                    getPageById: function getPageById(params) {
                        return _this2._send(constants.IBONUS_PATH_GET_PAGE_BY_ID, params);
                    }
                },
                sendCode: function sendCode(_ref18) {
                    var login = _ref18.login,
                        id_shop = _ref18.id_shop;

                    return _this2._send(constants.IBONUS_PATH_USER_SEND_CODE, { login: login, online_shop_id: id_shop });
                },
                /*
                    login - логин юзера (телефон)
                    source - <надо описать>
                    phone - телефон, куда слать
                    Если телефон еще не заполнен, то login и phone идентичны -
                    phone в этом случае нужен серву, чтобо отослать код, потому как по login
                    он не найдет юзера(телефон не заполнял же).
                */

                sendVoiceCode: function sendVoiceCode(_ref19) {
                    var login = _ref19.login,
                        source = _ref19.source,
                        phone = _ref19.phone;

                    return _this2._send(constants.IBONUS_PATH_USER_SEND_VOICE_CODE, { login: login, source: source, phone: phone });
                },

                restorePassword: function restorePassword(_ref20) {
                    var login = _ref20.login,
                        new_password = _ref20.new_password,
                        code = _ref20.code,
                        client_id = _ref20.client_id,
                        client_secret = _ref20.client_secret,
                        remember_me = _ref20.remember_me;

                    return _this2._send(constants.IBONUS_PATH_USER_RESTORE_PASSWORD, {
                        code: code,
                        client_id: client_id,
                        client_secret: client_secret,
                        remember_me: remember_me,
                        login: login,
                        new_password: new_password,
                        new_repassword: new_password

                    });
                },
                changeName: function changeName(_ref21) {
                    var pipo_id = _ref21.pipo_id,
                        name = _ref21.name,
                        new_name = _ref21.new_name,
                        access_token = _ref21.access_token,
                        client_id = _ref21.client_id,
                        client_secret = _ref21.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_NAME, {
                        pipo_id: pipo_id, name: name, new_name: new_name, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                changeMail: function changeMail(_ref22) {
                    var pipo_id = _ref22.pipo_id,
                        email = _ref22.email,
                        new_email = _ref22.new_email,
                        code = _ref22.code,
                        access_token = _ref22.access_token,
                        client_id = _ref22.client_id,
                        client_secret = _ref22.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_MAIL, {
                        pipo_id: pipo_id, email: email, new_email: new_email, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                changeMailWithCode: function changeMailWithCode(_ref23) {
                    var pipo_id = _ref23.pipo_id,
                        email = _ref23.email,
                        new_email = _ref23.new_email,
                        code = _ref23.code,
                        access_token = _ref23.access_token,
                        client_id = _ref23.client_id,
                        client_secret = _ref23.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_MAIL, {
                        pipo_id: pipo_id, email: email, new_email: new_email, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                changePhone: function changePhone(_ref24) {
                    var pipo_id = _ref24.pipo_id,
                        new_phone = _ref24.new_phone,
                        code = _ref24.code,
                        access_token = _ref24.access_token,
                        client_id = _ref24.client_id,
                        client_secret = _ref24.client_secret;

                    var newPhone = '+' + new_phone;
                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_PHONE, {
                        pipo_id: pipo_id, newPhone: newPhone, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                changePhoneWithCode: function changePhoneWithCode(_ref25) {
                    var pipo_id = _ref25.pipo_id,
                        new_phone = _ref25.new_phone,
                        code = _ref25.code,
                        access_token = _ref25.access_token,
                        client_id = _ref25.client_id,
                        client_secret = _ref25.client_secret;

                    var newPhone = '+' + new_phone;
                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_PHONE, {
                        pipo_id: pipo_id, newPhone: newPhone, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                confirmMail: function confirmMail(_ref26) {
                    var pipo_id = _ref26.pipo_id,
                        code = _ref26.code,
                        access_token = _ref26.access_token,
                        client_id = _ref26.client_id,
                        client_secret = _ref26.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_MAIL, {
                        pipo_id: pipo_id, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                confirmMailWithCode: function confirmMailWithCode(_ref27) {
                    var pipo_id = _ref27.pipo_id,
                        code = _ref27.code,
                        access_token = _ref27.access_token,
                        client_id = _ref27.client_id,
                        client_secret = _ref27.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_MAIL, {
                        pipo_id: pipo_id, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                confirmPhone: function confirmPhone(_ref28) {
                    var pipo_id = _ref28.pipo_id,
                        phone = _ref28.phone,
                        code = _ref28.code,
                        access_token = _ref28.access_token,
                        client_id = _ref28.client_id,
                        client_secret = _ref28.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_PHONE, {
                        pipo_id: pipo_id, phone: phone, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                confirmPhoneWithCode: function confirmPhoneWithCode(_ref29) {
                    var pipo_id = _ref29.pipo_id,
                        phone = _ref29.phone,
                        code = _ref29.code,
                        access_token = _ref29.access_token,
                        client_id = _ref29.client_id,
                        client_secret = _ref29.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_PHONE, {
                        pipo_id: pipo_id, phone: phone, code: code, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                changePassword: function changePassword(_ref30) {
                    var login = _ref30.login,
                        new_password = _ref30.new_password,
                        new_repassword = _ref30.new_repassword,
                        old_password = _ref30.old_password,
                        access_token = _ref30.access_token,
                        client_id = _ref30.client_id,
                        client_secret = _ref30.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_CHANGE_PASSWORD, {
                        login: login, new_password: new_password, new_repassword: new_repassword, old_password: old_password, access_token: access_token, client_id: client_id, client_secret: client_secret
                    });
                },
                updateInn: function updateInn(_ref31) {
                    var access_token = _ref31.access_token,
                        client_id = _ref31.client_id,
                        client_secret = _ref31.client_secret,
                        inn = _ref31.inn;

                    return _this2._send(constants.IBONUS_PATH_UPDATE_INN, { access_token: access_token, client_id: client_id, client_secret: client_secret, inn: inn });
                },
                updateUlName: function updateUlName(_ref32) {
                    var access_token = _ref32.access_token,
                        client_id = _ref32.client_id,
                        client_secret = _ref32.client_secret,
                        ul_name = _ref32.ul_name;

                    return _this2._send(constants.IBONUS_PATH_UPDATE_UL_NAME, { access_token: access_token, client_id: client_id, client_secret: client_secret, ul_name: ul_name });
                },
                addAddress: function addAddress(_ref33) {
                    var access_token = _ref33.access_token,
                        client_id = _ref33.client_id,
                        client_secret = _ref33.client_secret,
                        address = _ref33.address;

                    return _this2._send(constants.IBONUS_PATH_USER_ADD_ADDRESS, { access_token: access_token, client_id: client_id, client_secret: client_secret, address: address });
                },
                loadAddresses: function loadAddresses(_ref34) {
                    var access_token = _ref34.access_token,
                        client_id = _ref34.client_id,
                        client_secret = _ref34.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_GET_ADDRESS, {
                        access_token: access_token,
                        client_id: client_id,
                        client_secret: client_secret
                    });
                },
                updateAddress: function updateAddress(_ref35) {
                    var access_token = _ref35.access_token,
                        id = _ref35.id,
                        address = _ref35.address,
                        is_default = _ref35.is_default,
                        client_id = _ref35.client_id,
                        client_secret = _ref35.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_UPDATE_ADDRESS, {
                        access_token: access_token,
                        id: id,
                        address: address,
                        is_default: is_default,
                        client_id: client_id,
                        client_secret: client_secret
                    });
                },
                deleteAddress: function deleteAddress(_ref36) {
                    var access_token = _ref36.access_token,
                        id = _ref36.id,
                        client_id = _ref36.client_id,
                        client_secret = _ref36.client_secret;

                    return _this2._send(constants.IBONUS_PATH_USER_DELETE_ADDRESS, {
                        access_token: access_token,
                        id: id,
                        client_id: client_id,
                        client_secret: client_secret
                    });
                },
                confirmEMailBySignature: function confirmEMailBySignature(_ref37) {
                    var access_token = _ref37.access_token,
                        client_id = _ref37.client_id,
                        client_secret = _ref37.client_secret,
                        confirm_signature = _ref37.confirm_signature,
                        order_id = _ref37.order_id;

                    return _this2._send(constants.IBONUS_PATH_USER_CONFIRM_EMAIL_TO_URL, {
                        access_token: access_token,
                        client_id: client_id,
                        client_secret: client_secret,
                        confirm_signature: confirm_signature,
                        order_id: order_id
                    });
                }
            };
        }
    }, {
        key: 'offer',
        get: function get() {
            var _this3 = this;

            return {
                /**
                 * Получить список товаров по типу для слайдера
                 * @param type Тип товаров(Новинки - 1, Хиты - 2, Популярное - 3)
                 * @param profile_id
                 */
                getSliderOfferByType: function getSliderOfferByType(_ref38) {
                    var type = _ref38.type,
                        profile_id = _ref38.profile_id,
                        channel_id = _ref38.channel_id;

                    return _this3._send(constants.IBONUS_PATH_SLIDER_GET_OFFER_BY_TYPE, {
                        type: type, profile_id: profile_id, channel_id: channel_id
                    });
                },
                /**
                 * Получить список категорий для слайдера
                 * @param profile_id
                 */
                getSliderByCategory: function getSliderByCategory(_ref39) {
                    var profile_id = _ref39.profile_id;

                    return _this3._send(constants.IBONUS_PATH_SLIDER_GET_CATEGORY, {
                        profile_id: profile_id
                    });
                },

                /**
                 * Вернуть предложения канала продаж, сгруппированные по категориям
                 */
                getCategoryByProfile: function getCategoryByProfile(params) {
                    return _this3._send(constants.IBONUS_PATH_GET_CATALOG, params);
                },
                getByCategory: function getByCategory(_ref40) {
                    var client_id = _ref40.client_id,
                        client_secret = _ref40.client_secret,
                        access_token = _ref40.access_token,
                        category_id = _ref40.category_id,
                        channel_id = _ref40.channel_id,
                        profile_id = _ref40.profile_id;

                    return _this3._send(constants.IBONUS_PATH_OFFER_GET_BY_CATEGORY, {
                        client_id: client_id, client_secret: client_secret, access_token: access_token, category_id: category_id, channel_id: channel_id, profile_id: profile_id
                    });
                },
                /**
                 * Получение методов оплаты доступных для указанного канала продаж
                 * @param channel_id
                 *
                 * @returns {Promise}
                 */
                getPaymentMethods: function getPaymentMethods(_ref41) {
                    var channel_id = _ref41.channel_id;
                    return _this3._send(constants.IBONUS_PATH_GET_PAYMENT_METHODS, { channel_id: channel_id });
                },

                'get': function get(_ref42) {
                    var client_id = _ref42.client_id,
                        client_secret = _ref42.client_secret,
                        channel_id = _ref42.channel_id,
                        profile_id = _ref42.profile_id,
                        _ref42$name = _ref42.name,
                        name = _ref42$name === undefined ? '' : _ref42$name,
                        _ref42$barcode = _ref42.barcode,
                        barcode = _ref42$barcode === undefined ? '' : _ref42$barcode,
                        _ref42$begin_time_cre = _ref42.begin_time_create,
                        begin_time_create = _ref42$begin_time_cre === undefined ? null : _ref42$begin_time_cre,
                        _ref42$end_time_creat = _ref42.end_time_create,
                        end_time_create = _ref42$end_time_creat === undefined ? null : _ref42$end_time_creat,
                        _ref42$begin_time_upd = _ref42.begin_time_update,
                        begin_time_update = _ref42$begin_time_upd === undefined ? null : _ref42$begin_time_upd,
                        _ref42$end_time_updat = _ref42.end_time_update,
                        end_time_update = _ref42$end_time_updat === undefined ? null : _ref42$end_time_updat,
                        _ref42$categories = _ref42.categories,
                        categories = _ref42$categories === undefined ? [] : _ref42$categories,
                        _ref42$channels = _ref42.channels,
                        channels = _ref42$channels === undefined ? [] : _ref42$channels,
                        _ref42$page_number = _ref42.page_number,
                        page_number = _ref42$page_number === undefined ? 0 : _ref42$page_number,
                        _ref42$page_size = _ref42.page_size,
                        page_size = _ref42$page_size === undefined ? 20 : _ref42$page_size;

                    // todo: переделать данное уродство
                    var params = { client_id: client_id, client_secret: client_secret, channel_id: channel_id, profile_id: profile_id, page_number: page_number, page_size: page_size };
                    var _fillParams = function _fillParams(key, value) {
                        if (value) {
                            params[key] = value;
                        }
                    };
                    _fillParams('name', name);
                    _fillParams('barcode', barcode);
                    _fillParams('begin_time_create', begin_time_create);
                    _fillParams('end_time_create', end_time_create);
                    _fillParams('begin_time_update', begin_time_update);
                    _fillParams('end_time_update', end_time_update);
                    if (categories.length > 0) {
                        params.categories = categories;
                    }
                    if (channels.length > 0) {
                        params.channels = channels;
                    }

                    return _this3._send(constants.IBONUS_PATH_OFFER_GET, params);
                },
                getCategoryRecommended: function getCategoryRecommended(params) {
                    return _this3._send(constants.IBONUS_PATH_GET_CATEGORY_RECOMENDED, params);
                },
                getDepthByCategory: function getDepthByCategory(params) {
                    return _this3._send(constants.IBONUS_PATH_OFFER_GET_DEPTH_BY_CATEGORY, params);
                },
                getInCategory: function getInCategory(params) {
                    return _this3._send(constants.IBONUS_PATH_OFFER_GET_IN_CATEGORY, params);
                },
                getById: function getById(params) {
                    return _this3._send(constants.IBONUS_PATH_OFFER_GET_BY_ID, params);
                },
                shareBasket: function shareBasket(params) {
                    return _this3._send(constants.IBONUS_PATH_SHARE_BASKET, params);
                },
                getSharedBasket: function getSharedBasket(params) {
                    return _this3._send(constants.IBONUS_PATH_GET_SHARED_BASKET, params);
                },
                getActualPrices: function getActualPrices(params) {
                    return _this3._send(constants.IBONUS_PATH_GET_ACTUAL_PRICES, params);
                },
                getCouponsByToken: function getCouponsByToken(params) {
                    return _this3._send(constants.IBONUS_PATH_GET_COUPONS_BY_TOKEN, params);
                }
            };
        }
    }, {
        key: 'category',
        get: function get() {
            var _this4 = this;

            return {
                getByChannel: function getByChannel(_ref43) {
                    var client_id = _ref43.client_id,
                        client_secret = _ref43.client_secret,
                        access_token = _ref43.access_token,
                        channel_id = _ref43.channel_id;

                    return _this4._send(constants.IBONUS_PATH_CATEGORY_GET_BY_CHANNEL, {
                        client_id: client_id, client_secret: client_secret, access_token: access_token, channel_id: channel_id
                    });
                }
            };
        }
    }, {
        key: 'channel',
        get: function get() {
            var _this5 = this;

            return {
                getLastUpdateDate: function getLastUpdateDate(_ref44) {
                    var client_id = _ref44.client_id,
                        channel_id = _ref44.channel_id,
                        client_secret = _ref44.client_secret;

                    return _this5._send(constants.IBONUS_PATH_GET_TIME_UPDATE_CHANNEL, {
                        client_id: client_id,
                        client_secret: client_secret,
                        channel_id: channel_id
                    });
                },
                getActualCatalogLabel: function getActualCatalogLabel(_ref45) {
                    var client_id = _ref45.client_id,
                        channel_id = _ref45.channel_id,
                        client_secret = _ref45.client_secret;

                    return _this5._send(constants.IBONUS_PATH_ACTUAL_CATALOG_LABEL, {
                        client_id: client_id,
                        client_secret: client_secret,
                        channel_id: channel_id
                    });
                }
            };
        }
    }, {
        key: 'lang',
        get: function get() {
            var _this6 = this;

            return {
                getLangData: function getLangData() {
                    return _this6._send(constants.IBONUS_PATH_LANG_GET_LANG_DATA);
                }
            };
        }
    }]);
    return IBonusApi;
}();

exports.default = IBonusApi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/api/IBonusApi.js
// module id = 1591
// module chunks = 0